import {
  Button,
  Drawer,
  Grid,
  List,
  ListItem,
  Menu,
  Modal,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import theme from "../../theme";
import { useAppSelector } from "../../redux/hooks";
import UpdateMemberForm from "../forms/UpdateMemberForm";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";
import { emailMasking, mobileNumberMasking } from "../../util/MaskingUtils";
import { constant } from "../../constants";
import { dateFormat, getFormattedDate } from "../../util/dateFormat";
import UpdateEmail from "../forms/UpdateEmail";
import useGetMemberDetails from "../../Hooks/member/useGetMemberDetails";
import { activityLogRefresh } from "./MemberDetailsHeaderNew";

const ProfileNew = () => {
  const { getUserPermission: getProfilePermission } = usePermissionGetter(
    "members",
    "members_search"
  );

  const [updateProfile, setUpdateProfile] = useState(false);
  const [updateEmail, setUpdateEmail] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [moreList, setMoreList] = useState([]);
  const memberDetails = useAppSelector(
    (state: any) => state.persistReducers.getMemberList?.membersList
  );

  const { getMemberDetails } = useGetMemberDetails(memberDetails.id);
  const newEmail = memberDetails.email;
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleOpenUpdateEmail = () => {
    setUpdateEmail(true);
  };

  const handleCloseUpdateEmail = () => {
    setUpdateEmail(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    setMoreList(memberDetails?.interest?.split(","));
  }, [memberDetails.interest]);

  const handlePageNavigation = () => {
    setUpdateEmail(false);
    getMemberDetails(memberDetails.id);
  };
  useEffect(() => {
    activityLogRefresh(newEmail);
  }, [newEmail]);

  return (
    <Grid height={"100%"} sx={{ padding: "0 16px" }} width={"100%"}>
      <Drawer
        anchor={"right"}
        open={updateProfile}
        onClose={() => {
          setUpdateProfile(false);
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px 0 0 16px",
          },
        }}
      >
        <Grid width={"920px"}>
          <UpdateMemberForm
            initialFormData={memberDetails}
            type="Update"
            closeUpdate={setUpdateProfile}
          />
        </Grid>
      </Drawer>
      <Modal
        open={updateEmail}
        onClose={() => {
          setUpdateEmail(false);
        }}
      >
        <Grid
          width={"500px"}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "16px",
          }}
        >
          <UpdateEmail
            handleCloseUpdateEmail={handleCloseUpdateEmail}
            handlePageNavigation={handlePageNavigation}
          />
        </Grid>
      </Modal>

      <Grid
        height={"10%"}
        display={"flex"}
        justifyContent={"end"}
        sx={{
          padding: " 16px 0",
          borderBottom: theme.border?.smallGrey,
          margin: "0 24px",
        }}
      >
        {getProfilePermission("update") && (
          <CommonButton
            buttonTitle=" Update Email"
            variant="text"
            color="secondary"
            onClick={handleOpenUpdateEmail}
          />
        )}
        {getProfilePermission("update") && (
          <CommonButton
            buttonTitle=" Update Profile"
            variant="text"
            color="secondary"
            onClick={() => {
              setUpdateProfile(!updateProfile);
            }}
          />
        )}
      </Grid>
      <Grid
        height={"25%"}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        gap={2}
        sx={{ margin: "0 24px" }}
        borderBottom={theme.border?.smallGrey}
      >
        <Grid display={"flex"} justifyContent={"space-around"} gap={2}>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              First Name
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {memberDetails.first_name ? memberDetails.first_name : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Last Name
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {memberDetails.last_name ? memberDetails.last_name : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Email
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {constant.domain === process.env.REACT_APP_CSA_DOMAIN
                ? emailMasking(memberDetails.email ? memberDetails.email : "-")
                : memberDetails.email
                ? memberDetails.email
                : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Date of Birth
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              {memberDetails.dob_date
                ? getFormattedDate(
                    memberDetails.dob_date,
                    dateFormat.DDWithSlash
                  )
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid display={"flex"} justifyContent={"space-around"} gap={2}>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Gender
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {memberDetails.gender ? memberDetails.gender : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Postal Code
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {memberDetails.zip ? memberDetails.zip : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Mobile No
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {constant.domain === process.env.REACT_APP_CSA_DOMAIN
                ? mobileNumberMasking(
                    memberDetails.mobile ? memberDetails.mobile : "-"
                  )
                : memberDetails.mobile
                ? memberDetails.mobile
                : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Country
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {memberDetails.country_of_residence
                ? memberDetails.country_of_residence
                : "-"}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        display={"flex"}
        sx={{ margin: "0 24px" }}
        borderBottom={theme.border?.smallGrey}
        gap={2}
        alignItems={"center"}
        height={"12.5%"}
      >
        <Grid width={"100%"}>
          <Typography
            sx={{
              color: "#949494",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 400,
              fontSize: "14px",
            }}
          >
            Is internal staff
          </Typography>
          <Typography
            sx={{
              color: "#797B83",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 600,
              fontSize: "14px",
            }}
          >
            {memberDetails.isinternalstaffdiamo === "YES" ||
            memberDetails.isinternstaffgold === "YES"
              ? "YES"
              : "NO"}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        display={"flex"}
        flexDirection={"column"}
        gap={2}
        justifyContent={"center"}
        height={"25%"}
        sx={{ margin: "0 24px" }}
        borderBottom={theme.border?.smallGrey}
      >
        <Grid display={"flex"}>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Member Type
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {memberDetails.member_type ? memberDetails.member_type : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Corporate Email
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
              width={"90%"}
            >
              {memberDetails.corporate_email
                ? memberDetails.corporate_email
                : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Corporate Company
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {memberDetails.company_name ? memberDetails.company_name : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid display={"flex"}>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Member Status
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {memberDetails.customer_status
                ? memberDetails.customer_status
                : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Interest
            </Typography>
            <Button
              onClick={handleClick}
              sx={{ textTransform: "none", marginLeft: "-8px" }}
            >
              <Typography
                sx={{
                  color: "#797B83",
                  fontFamily: theme.font?.fontFamily.primary,
                  fontWeight: 600,
                  fontSize: "14px",
                }}
              >
                {memberDetails?.interest
                  ? memberDetails?.interest?.split(",")[0] +
                    (memberDetails?.interest?.split(",").length > 1
                      ? ` + ${
                          memberDetails?.interest?.split(",").length - 1
                        } more`
                      : "")
                  : "-"}
              </Typography>
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              <Grid width={"241px"} overflow={"auto"}>
                <List>
                  {moreList?.map((item: any) => (
                    <ListItem>{item}</ListItem>
                  ))}
                </List>
              </Grid>
            </Menu>
          </Grid>
          <Grid width={"50%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Where did you hear about us
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              {memberDetails.heard_about_us
                ? memberDetails.heard_about_us
                : "-"}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        display={"flex"}
        sx={{ margin: "0 24px" }}
        alignItems={"center"}
        height={"12.5%"}
        borderBottom={theme.border?.smallGrey}
      >
        <Grid width={"25%"}>
          <Typography
            sx={{
              color: "#949494",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 400,
              fontSize: "14px",
            }}
          >
            IU number
          </Typography>
          <Typography
            sx={{
              color: "#797B83",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 600,
              fontSize: "14px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {memberDetails?.vehicleDetails?.length &&
            memberDetails?.vehicleDetails[0]?.iuNumber
              ? memberDetails?.vehicleDetails[0]?.iuNumber
              : ""}
            <br></br>
            {memberDetails?.vehicleDetails?.length &&
            memberDetails?.vehicleDetails[1]?.iuNumber
              ? memberDetails?.vehicleDetails[1]?.iuNumber
              : ""}
          </Typography>
        </Grid>
        <Grid width={"25%"}>
          <Typography
            sx={{
              color: "#949494",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 400,
              fontSize: "14px",
            }}
          >
            License Plate
          </Typography>
          <Typography
            sx={{
              color: "#797B83",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 600,
              fontSize: "14px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {memberDetails?.vehicleDetails?.length &&
            memberDetails?.vehicleDetails[0]?.carPlateNumber
              ? memberDetails?.vehicleDetails[0]?.carPlateNumber
              : ""}
            <br></br>
            {memberDetails?.vehicleDetails?.length &&
            memberDetails?.vehicleDetails[1]?.carPlateNumber
              ? memberDetails?.vehicleDetails[1]?.carPlateNumber
              : ""}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        display={"flex"}
        sx={{ margin: "0 24px" }}
        alignItems={"center"}
        height={"15%"}
      >
        <Grid width={"50%"}>
          <Typography
            sx={{
              color: "#949494",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 400,
              fontSize: "14px",
            }}
          >
            Communication Preferences
          </Typography>
          <Typography
            sx={{
              color: "#797B83",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 600,
              fontSize: "14px",
            }}
          >
            {memberDetails.subscr_for_mkt === true &&
            memberDetails.subscr_for_news === true
              ? "Push Notification, Email"
              : memberDetails.subscr_for_mkt === true
              ? "Push Notification"
              : memberDetails.subscr_for_news === true
              ? "Email"
              : "-"}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
    // }</>
  );
};

export default ProfileNew;
